package com.bulut.mecitogullari.data.repository

import com.bulut.mecitogullari.data.model.CashTransaction
import kotlinx.coroutines.flow.Flow

interface TransactionRepository {
    val transactions: Flow<List<CashTransaction>>
    suspend fun get(transactionId: String): CashTransaction?
    suspend fun upsert(transaction: CashTransaction)
    suspend fun delete(transactionId: String)
}

class FirestoreTransactionRepository : TransactionRepository {

    override val transactions: Flow<List<CashTransaction>> =
        userCollectionFlow(COLLECTION)

    override suspend fun get(transactionId: String): CashTransaction? {
        val uid = currentUid() ?: return null
        val snapshot = userCollection(uid, COLLECTION).document(transactionId).get()
        return if (snapshot.exists) runCatching { snapshot.data<CashTransaction>() }.getOrNull() else null
    }

    override suspend fun upsert(transaction: CashTransaction) {
        val uid = currentUid() ?: return
        userCollection(uid, COLLECTION).document(transaction.id).set(transaction)
    }

    override suspend fun delete(transactionId: String) {
        val uid = currentUid() ?: return
        userCollection(uid, COLLECTION).document(transactionId).delete()
    }

    private companion object {
        const val COLLECTION = "transactions"
    }
}
